import React, { useEffect, useState } from "react";
import PageBar from "../../components/dashboard/page-bar/PageBar";

import CategoryList from "../../components/category/categoryList/CategoryList";
import { Helmet } from "react-helmet";
import axios from "axios";
import { Loaders } from "../Loaders";

const CategoryListPage = () => {
  const [loader, setLoader] = useState(false)
  const [data, setData] = useState();
  const [count, setCount] = useState(10)
  const [page, setPage] = useState(1)

  const [initialVlue, setInitialVlue] = useState({
    search: '',
  })
  const handleChange = (e) => {
    const clone = { ...initialVlue }
    const value = e.target.value
    const name = e.target.name
    clone[name] = value
    setInitialVlue(clone)
  }
  const getCategoryData = async (page) => {
    setLoader(true)
    const clone = { ...initialVlue, page: page, count: count }
    try {
      const res = await axios.get(
        `https://abarishr.hennainternational.in/api/job-category/all?count=${clone?.count}&page=${clone?.page}&search=${clone?.search}`
      );
      setData(res?.data);
      setLoader(false)
    } catch (error) { setLoader(false) }
  };
  const reset = async (page) => {
    setLoader(true)
    const clone = { search: '', page: page, count: count }
    try {
      const res = await axios.get(
        `https://abarishr.hennainternational.in/api/job-category/all?count=${clone?.count}&page=${clone?.page}&search=${clone?.search}`
      );
      setData(res?.data);
      setInitialVlue({
        search: ''
      })
      setLoader(false)
    } catch (error) { setLoader(false) }
  }
  const getCategoryData2 = async (num) => {
    try {
      const res = await axios.get(
        `https://abarishr.hennainternational.in/api/job-category/all?page=${num}`
      );
      setData(res?.data);
    } catch (error) { }
  };
  const searchData = async (val) => {
    try {
      const res = await axios.get(
        `https://abarishr.hennainternational.in/api/job-category/search/${val}`
      );
      setData(res);

    } catch (error) { }
  };

  useEffect(() => {
    getCategoryData(1);
  }, []);
  const onChangeVal = (e) => {
    // console.log(e);
    getCategoryData(e)

  };

  return (
    <>
      {loader && <Loaders />}
      <Helmet>
        <title>Category List</title>
        <meta name="keyword" content="Jobs, Find Job, Give " />
        <meta name="description" content="" />
      </Helmet>
      <div className="pageWrapper">
        <PageBar title="Category" />
        <h3 className="page-title">
          Manage Category
        </h3>
        <CategoryList getCategoryData2={getCategoryData2} data={data} getCategoryData={getCategoryData} searchData={searchData} onChangeVal={onChangeVal} initialVlue={initialVlue} handleChange={handleChange} reset={reset} />
      </div>
    </>
  );
};

export default CategoryListPage;
